<div class="confirmation">
  <div class="row">
    <div class="col-md-6 margin-fix">
      <h4>{{ headerText }}</h4>
      <h5 class="confirmation-text">Your confirmation number: {{ exchangeConfirmationNumber }}</h5>
      <br />
      <p>{{ actionMessage }}</p>
    </div>
    <div class="col-md-6 margin-fix">
      <button
        class="button fm-secondary-button export-pdf"
        [disabled]="exportPDFButtonClicked"
        (click)="downloadPDF()"
      >
        <i class="fa fa-file-pdf-o button-icon"></i>EXPORT PDF
      </button>
    </div>
  </div>

  <hr class="margin-fix" />

  <ng-container *ngIf="showBanner">
    <div class="alert-margin">
      <invd-fm-message-alerts
        [messageTitle]="messageTitle"
        [messageBody]="messageBody"
        [messageType]="messageType"
      ></invd-fm-message-alerts>
    </div>
  </ng-container>

  <ng-container *ngIf="showEarlyCloseBanner">
    <div class="alert-margin">
      <invd-fm-message-alerts
        *ngFor="let messageInfo of warningMessages; trackBy: trackByIdentity"
        [messageTitle]="messageInfo.title"
        [messageBody]="messageInfo.message"
        [messageType]="messageInfo.type"
      ></invd-fm-message-alerts>
    </div>
  </ng-container>

  <div class="row">
    <div class="col-md-6 margin-fix">
      <p>Deal Number: {{ dealNumber }}</p>
      <p>Dealer: {{ dealerName }}</p>
      <p>Dealer Contact: {{ traderName }}</p>
      <p>Exchange Date: {{ exchangeSettlementDate | date: 'MM/dd/yyyy' }}</p>
      <br />
      <p>{{ memoText }}</p>
    </div>
  </div>

  <div class="row">
    <invd-commit-exchange-table
      title="Bonds to be Delivered to Fannie Mae"
      [dataProvider]="distributedBondsDataProvider"
      [isDisplayRecom]="displayRecomColumn"
    ></invd-commit-exchange-table>
    <invd-commit-exchange-table
      title="Bonds to be Received from Fannie Mae"
      [dataProvider]="receivedBondsDataProvider"
      [isDisplayRecom]="displayRecomColumn"
    ></invd-commit-exchange-table>
  </div>

  <div class="row propertyGroup" *ngIf="!isTakedownFlow">
    <ng-container *ngIf="feeCurrentFace === 0">
      <div>
        <label class="propertyName">Current Face:</label>
        <label class="propertyValue">{{
          feeCurrentFaceNotional | currency: 'USD' : 'symbol' : '1.2-2'
        }}</label>
      </div>
    </ng-container>
    <ng-container *ngIf="feeCurrentFace !== 0">
      <div>
        <label class="propertyName">Current Face: </label>
        <label class="propertyValue">{{
          feeCurrentFace | currency: 'USD' : 'symbol' : '1.2-2'
        }}</label>
      </div>
    </ng-container>

    <div>
      <label class="propertyName highlight">Fee: </label>
      <label class="propertyValue highlight">{{ feeTicks | number: '1.2-2' }}/32</label>
    </div>
    <div>
      <label class="propertyName">Total Fee:</label>
      <label class="propertyValue">{{ feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}</label>
    </div>
    <div>
      <label class="propertyName">Settlement Date:</label>
      <label class="propertyValue">{{ exchangeSettlementDate }}</label>
    </div>
  </div>

  <div class="refresh-confirm-model-window" *ngIf="displayBackBtnClickPanel">
    <div class="panel panel-default">
      <button type="button" class="close float-end" aria-label="Close" (click)="dismissPopup()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body">
        <i class="fa fa-exclamation-triangle warning-icon"></i>
        <h4>We noticed that you clicked the back button</h4>
        <p>
          If you were trying to make edits to this exchange, please go to your Committed Exchanges
          page.
        </p>
        <button class="button fm-primary-button" (click)="dismissPopup()">OKAY</button>
      </div>
    </div>
  </div>
</div>
